import { render, staticRenderFns } from "./serviceAi.vue?vue&type=template&id=130f84d3&"
import script from "./serviceAi.vue?vue&type=script&lang=js&"
export * from "./serviceAi.vue?vue&type=script&lang=js&"
import style0 from "./serviceAi.vue?vue&type=style&index=0&id=130f84d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports